import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { EmptyText, ScriptContent } from './styled-components'
import type { SalesScriptStatus } from './useSalesScript'

interface SalesScriptContentProps {
  content: string
  status: SalesScriptStatus
  emptyText: string
  errorText: string
}

const SalesScriptContent = ({ content, status, emptyText, errorText }: SalesScriptContentProps) => (
  <>
    <ScriptContent hidden={status !== 'ready'} dangerouslySetInnerHTML={{ __html: content }} />
    <EmptyText hidden={status !== 'empty'}>{emptyText}</EmptyText>
    <SDNotification type='negative' hidden={status !== 'error'} primaryText={errorText} />
  </>
)

export default SalesScriptContent
